var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require(
  _vm.isOpen ?
  '@/assets/arrows/keyboard-arrow-top.svg' :
  '@/assets/arrows/keyboard-arrow-bottom.svg')}})}
var staticRenderFns = []

export { render, staticRenderFns }